<template>
  <v-card data-testid="certification-form">
    <v-card-title class="primary white--text">
      <span class="headline">{{ title }}</span>
      <v-spacer/>
      <BaseDialogActions hideRefresh hideFullscreen/>
    </v-card-title>
    <v-card-text>
      <FormWrapper
        ref="form"
        formRef="certificationForm"
        testId="save-certification"
        :lazyValidation="true"
        :buttonText="saveBtnText"
        @submit="saveCertification"
      >
      <v-container grid-list-lg>
        <v-row wrap>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="certification.name"
              data-testid="certification-name"
              :rules="[rules.required]"
              :label="$t('name')"
              ref="firstField"
              color="black"
              counter="64"
              maxlength="64"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="certification.code"
              data-testid="certification-code"
              :label="$t('code')"
              color="black"
              counter="5"
              maxlength="5"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="isTractCertification">
            <v-autocomplete
              v-model="certification.basisCertificationIds"
              data-testid="certification-basis"
              :items="availableBasisCertifications"
              :label="$t('basisAccountCertifications')"
              :hint="$t('basisAccountCertificationsHint')"
              :no-data-text="$t('noAvailableCertifications')"
              :menu-props="{ maxHeight: 200, contentClass: 'certification-basis-menu' }"
              item-text="name"
              item-value="certificationId"
              multiple
              chips
              deletable-chips
              persistent-hint
              color="black"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-container>
      </FormWrapper>
    </v-card-text>
  </v-card>
</template>

<script>
import fieldRules from '@/utils/rules'
import { CertificationCategory } from '@/utils/Enumerations'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'CertificationForm',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue'),
    FormWrapper: () => import('@/components/core/FormWrapper.vue')
  },

  props: {
    isEditing: Boolean,
    certificationCategory: String,
    propCertification: Object
  },

  data: () => ({
    rules: fieldRules.rules,
    certification: {
      certificationId: -1,
      code: '',
      name: '',
      basisCertificationIds: []
    }
  }),

  created () {
    if (this.isEditing) {
      this.certification = JSON.parse(JSON.stringify(this.propCertification))
      this.certification.basisCertificationIds = this.certification.basisCertificationIds ?? []
    }
  },

  mounted () {
    setTimeout(_ => {
      this.$refs.firstField.focus()
    }, 0)
  },

  computed: {
    ...mapGetters('certification', ['accountCertifications']),

    title () {
      return this.isEditing ? this.$t('editingCertification', { type: this.certificationCategory }) : this.$t('creatingCertification', { type: this.certificationCategory })
    },

    saveBtnText () {
      return this.isEditing ? this.$t('saveChanges') : this.$t('createNewCertification')
    },
    category () {
      return this.propCertification?.category ?? this.certificationCategory
    },

    isTractCertification () {
      const category = this.propCertification?.category ?? CertificationCategory.toInt(this.certificationCategory)
      return category === CertificationCategory.Tract.value
    },

    availableBasisCertifications () {
      return this.accountCertifications
        .filter(c => c.certificationId !== this.certification.certificationId)
        .sort((a, b) => a.name.localeCompare(b.name))
    }
  },

  methods: {
    ...mapActions('certification', ['createCertification', 'updateCertification']),

    async saveCertification () {
      if (!this.$refs.form.$refs.certificationForm.validate()) {
        return
      }

      if (this.isEditing) {
        await this.updateCertification(this.certification)
        this.$emit('certification-mutated')
      } else {
        const category = CertificationCategory.toInt(this.category)
        const response = await this.createCertification({
          name: this.certification.name,
          code: this.certification.code,
          category,
          basisCertificationIds: this.isTractCertification ? this.certification.basisCertificationIds : []
        })
        this.$emit('certification-mutated', response)
      }
    }
  }
}
</script>
